import { getDialogData } from 'lib/helpers/getDialogData/getDialogData'
import { useDialogStore, type DialogState } from '../useDialogStore/useDialogStore'

export type DialogStateHookReturn<T> = [DialogState<T>['open'], DialogState<T>['data']]

/**
 * @deprecated Use `useDialog` from `lib/hooks/useDialog/useDialog` instead.
 * This is a low-level read-only hook — `useDialog` combines it with `useSetDialogState` in a single call.
 */
export const useDialogState = <T>(id: string): DialogStateHookReturn<T> => {
  const open = useDialogStore(({ state }) => state[id]?.open || false)
  const data = useDialogStore(({ state }) => getDialogData<T>(state[id]))

  return [open, data]
}
